import { PayPalButtons } from "@paypal/react-paypal-js";
import { useState } from "react";
import { API_BASE_URL } from '../config.js';
import "./BuyButton.css";

function BuyButton({ price, title, releaseId }) {
  const [purchased, setPurchased] = useState(false);

  if (purchased) {
    return <p className="buy-confirmation">Thanks for buying {title}!</p>;
  }

  return (
    <PayPalButtons
      fundingSource="paypal"
      style={{ layout: "horizontal", height: 35, label: "buynow" }}
      createOrder={async () => {
        const res = await fetch(`${API_BASE_URL}/api/orders`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ releaseId, purchase_type: "physical" }),
        });
        const order = await res.json();
        if (!res.ok) throw new Error(order.error || "Could not create order");
        return order.orderID;
      }}
      onApprove={async (data) => {
        const res = await fetch(`${API_BASE_URL}/api/orders/${data.orderID}/capture`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        });
        const details = await res.json();
        if (details.status === "completed") {
          setPurchased(true);
        }
      }}
    />
  );
}

export default BuyButton;
